// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"336":"62581877","839":"a29899d9"}[chunkId] + ".chunk.css";
};